import ConfirmAction from '@/components/confirm-action';
import PageToolbar from '@/components/linear/page-toolbar';
import { documentPath, documentsPath } from '@/lib/linear-paths';
import type { WorkspaceDocument } from '@/types/document';
import { Link, router } from '@inertiajs/react';
import { useState } from 'react';

interface Props {
  document: WorkspaceDocument;
}

export default function Show({ document }: Props) {
  const [title, setTitle] = useState(document.title);
  const [body, setBody] = useState(document.body ?? '');

  const save = (next: { title?: string; body?: string }) => {
    router.patch(
      documentPath(document.id),
      { document: { title: next.title ?? title, body: next.body ?? body } },
      { preserveScroll: true }
    );
  };

  return (
    <div className="ln-page">
      <PageToolbar
        title="Documents"
        showNew={false}
        tabs={
          <Link href={documentsPath()} className="ln-tab">
            All documents
          </Link>
        }
        actions={
          <ConfirmAction
            title="Delete document?"
            onConfirm={() => router.delete(documentPath(document.id))}
          >
            <button type="button" className="ln-toolbar-btn">
              Delete
            </button>
          </ConfirmAction>
        }
      />
      <div className="ln-page-scroll" style={{ padding: 32, maxWidth: 720 }}>
        <input
          className="ln-detail-title"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          onBlur={() => {
            if (title.trim() && title !== document.title) save({ title });
          }}
          aria-label="Document title"
        />
        <textarea
          className="ln-detail-description"
          value={body}
          onChange={(event) => setBody(event.target.value)}
          onBlur={() => {
            if (body !== (document.body ?? '')) save({ body });
          }}
          placeholder="Write…"
          aria-label="Document body"
          style={{ minHeight: 320 }}
        />
      </div>
    </div>
  );
}
